export default {
	items: [
		{
			name: 'Dashboard',
			url: '/dashboard',
			icon: 'icon-speedometer',
		},
		{
			name: 'Sucursales',
			url: '/accounts',
			icon: 'icon-layers',
		},
		{
			name: 'Proyectos',
			url: '/projects',
			icon: 'icon-folder',
		},
		{
			name: 'Mi Perfil',
			icon: 'icon-user',
			children: [
				{
					name: 'Detalle',
					url: '/auth/user-detail',
					icon: 'icon-puzzle',
				},
				{
					name: 'Cambiar Contraseña',
					url: '/auth/change-password',
					icon: 'icon-puzzle',
				}
			]
		},
		{
			name: 'Cerrar Sesión',
			url: '/logout',
			icon: 'icon-logout'
		},
	]
}
